/**
 * AnalyticsService
 * 
 * Handles privacy-respecting event tracking and engagement monitoring.
 * Only dispatches events if corresponding consent is granted.
 */

export class AnalyticsService extends EventTarget {
    constructor() {
        super();
        this.consent = { performance: false, marketing: false };
        try {
            const saved = localStorage.getItem('cytific_consent_prefs');
            if (saved) this.consent = JSON.parse(saved);
        } catch (e) { }
        window.addEventListener('cytific:consent_updated', (e) => {
            this.consent = e.detail;
            console.log('AnalyticsService: Consent updated', this.consent);
        });
    }

    /**
     * Track an engagement event
     * @param {string} eventName 
     * @param {Object} props 
     */
    trackEvent(eventName, props = {}) {
        // 1. Always log to console for debugging/transparency if performance consent is on
        if (this.consent.performance) {
            console.log(`[ANALYTICS:PERFORMANCE] ${eventName}`, props);

            // In a real implementation, you would send this to your backend or GA here:
            // fetch('/api/analytics', { method: 'POST', body: JSON.stringify({ eventName, props, ts: Date.now() }) });
        }

        // 2. Marketing specific tracking
        if (this.consent.marketing) {
            // Potentially signal to AdSense or other providers
            // e.g., window.adsbygoogle.push({ params: { ... } });
            console.log(`[ANALYTICS:MARKETING] ${eventName}`, props);
        }

        this.dispatchEvent(new CustomEvent('analytics:log', { detail: { eventName, props } }));
    }

    /**
     * Monitor specialized engagement (e.g. ad visibility)
     */
    trackAdEvent(type, adId) {
        if (this.consent.marketing) {
            this.trackEvent(`ad_${type}`, { adId });
        }
    }
}

export const analyticsService = new AnalyticsService();
